var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSleetShower01 = function SvgSleetShower01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 5.43,
    y1: 177.1,
    x2: 162.6,
    y2: 19.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 79.97,
    y1: 251.64,
    x2: 237.15,
    y2: 94.46,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 3.57,
    y1: 175.24,
    x2: 160.75,
    y2: 18.07,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 34.44,
    y1: 206.11,
    x2: 191.62,
    y2: 48.93,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 58.11,
    y1: 229.78,
    x2: 215.28,
    y2: 72.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -2.15,
    y1: 169.52,
    x2: 155.03,
    y2: 12.34,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 14.49,
    y1: 186.16,
    x2: 171.67,
    y2: 28.99,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 29.54,
    y1: 201.21,
    x2: 186.72,
    y2: 44.04,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 45.55,
    y1: 217.23,
    x2: 202.73,
    y2: 60.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 63.18,
    y1: 234.85,
    x2: 220.36,
    y2: 77.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 76,
    y1: 247.67,
    x2: 233.18,
    y2: 90.49,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M156.72,28.95c-3.22,0-6.51.44-9.99,1.32C138.24,11.77,120.09,0,99.59,0,76.88,0,56.98,14.53,50.06,36.15c-.63,1.96.45,4.05,2.41,4.67,1.96.63,4.05-.45,4.67-2.41,5.93-18.53,22.99-30.99,42.45-30.99,17.29,0,32.63,9.79,40.05,25.25-5.1,2.33-8.63,5.78-10.8,8.53-1.27,1.61-.99,3.95.62,5.22.68.54,1.49.8,2.3.8,1.1,0,2.19-.49,2.92-1.42,2.01-2.55,5.54-5.92,10.94-7.47.02,0,.1-.03.13-.04,3.96-1.29,7.55-1.92,10.98-1.92,19.64,0,35.63,15.98,35.63,35.63s-15.98,35.63-35.63,35.63H43.08c-14.8,0-26.84-12.04-26.84-26.83s12.04-26.84,26.84-26.84c2.19,0,4.47.36,7.18,1.12,3.56,1.07,6.86,3,9.3,5.43.73.72,1.67,1.08,2.62,1.08s1.91-.37,2.64-1.1c1.45-1.46,1.44-3.81-.01-5.26-3.3-3.28-7.71-5.87-12.43-7.29-.01,0-.02,0-.04,0-.01,0-.02-.01-.03-.02-3.41-.95-6.34-1.4-9.23-1.4-18.9,0-34.27,15.37-34.27,34.27s15.37,34.27,34.27,34.27h113.64c23.75,0,43.06-19.32,43.06-43.06,0-23.75-19.32-43.06-43.06-43.06"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M149.2,169.5c-7.14,0-12.92,5.78-12.92,12.92s5.78,12.92,12.92,12.92,12.91-5.78,12.91-12.92-5.78-12.91-12.91-12.92M149.2,188.71c-3.48,0-6.31-2.83-6.31-6.31s2.83-6.31,6.31-6.31,6.31,2.83,6.31,6.31-2.83,6.31-6.31,6.31"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M13.13,152.76c-7.14,0-12.92,5.78-12.92,12.92s5.78,12.92,12.92,12.91c7.14,0,12.91-5.78,12.91-12.92-.01-7.13-5.79-12.9-12.92-12.91M13.14,171.98c-3.48,0-6.31-2.83-6.31-6.31s2.81-6.31,6.3-6.31,6.31,2.81,6.32,6.3c0,3.48-2.83,6.31-6.31,6.32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M58.14,166.81c-8.62,0-15.59,6.98-15.59,15.59s6.99,15.59,15.59,15.59,15.59-6.98,15.59-15.59-6.99-15.58-15.59-15.59M58.14,191.4c-4.96,0-8.99-4.02-8.99-8.98s4.03-8.98,8.99-8.98,8.98,4.02,8.98,8.98-4.03,8.98-8.98,8.98"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M151.49,126.14c-5.66,0-10.24,4.58-10.24,10.24s4.59,10.23,10.24,10.24c5.66,0,10.25-4.58,10.25-10.24s-4.59-10.24-10.25-10.24M151.49,140.02c-2,0-3.64-1.62-3.64-3.64s1.63-3.64,3.64-3.64,3.64,1.63,3.64,3.64-1.63,3.64-3.64,3.64"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M38.01,132.73l-10.11,12.66c-.72.95-1.92,1.43-3.1,1.27-1.18-.18-2.19-.97-2.61-2.09-.44-1.12-.22-2.38.55-3.3l10.11-12.66c.72-.95,1.91-1.43,3.1-1.26,1.18.18,2.18.96,2.61,2.08.43,1.12.22,2.39-.55,3.3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M43.87,161.9c-1.27,0-2.43-.72-2.98-1.87s-.39-2.51.39-3.49l14.28-17.88c1.14-1.42,3.22-1.66,4.64-.53s1.66,3.22.53,4.64l-14.28,17.88c-.64.79-1.58,1.25-2.58,1.25"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M96.36,136.62l-19.18,24.02c-1.14,1.42-3.22,1.66-4.64.53-1.42-1.14-1.66-3.22-.53-4.64l19.18-24.04c1.14-1.42,3.22-1.66,4.64-.53,1.42,1.14,1.66,3.22.53,4.64h0Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M130.2,132.73l-35.62,44.62c-1.14,1.42-3.22,1.66-4.65.53-1.42-1.14-1.65-3.22-.51-4.64l35.62-44.62c1.14-1.42,3.22-1.65,4.64-.53,1.42,1.14,1.66,3.22.53,4.64Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M142.15,156.22l-33.95,42.53c-1.14,1.42-3.22,1.66-4.64.53-1.42-1.14-1.66-3.22-.53-4.64l33.95-42.53c1.14-1.42,3.22-1.66,4.64-.53,1.42,1.14,1.65,3.22.53,4.64"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M182.75,143.87l-13.39,16.78c-1.14,1.42-3.22,1.66-4.64.53-1.42-1.14-1.66-3.22-.53-4.64l13.39-16.78c1.14-1.42,3.22-1.66,4.64-.53s1.66,3.22.53,4.64"
  })));
};
export default SvgSleetShower01;